"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
/**
 * Redux Hooks Plugin
 *
 * generates redux hooks for store
 */
exports.default = (function (_a) {
    var context = _a.context;
    var useSelector = react_redux_1.createSelectorHook(context);
    var useDispatch = react_redux_1.createDispatchHook(context);
    return {
        onStoreCreated: function () {
            return {
                useSelector: useSelector,
                useDispatch: useDispatch,
            };
        },
    };
});
//# sourceMappingURL=reduxHooks.js.map